import { Dialog, IconButton, useMediaQuery, useTheme } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

import '../../../assets/style/styleModalList.css';

import { ComprasForm } from './ComprasForm';

export const ComprasModalNuevoGasto = ({ title, open, setOpenExtendedMode, initialState, loadIniBudget }) => {

    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm')); // móvil: sm o menor

    return (
        <Dialog
            // className='dialogModalList'
            open={open}
            onClose={() => setOpenExtendedMode(false)}
            aria-labelledby="simple-dialog-title"
            PaperProps={{
                className: isMobile ? '' : 'min-w-fit'
            }}
        >
            <div className='ContainerDialogs'>
                <h1 className='TitleModalPresupuesto'>
                    {title}
                    <IconButton
                        style={{ padding: '0', float: 'right' }}
                        aria-label="close"
                        onClick={() => setOpenExtendedMode(false)}
                    >
                        <CloseIcon />
                    </IconButton>
                </h1>

                <ComprasForm
                    initialState={initialState}
                    loadIniBudget={loadIniBudget}
                    setOpenExtendedMode={setOpenExtendedMode}
                />

            </div>
        </Dialog>
    )
}
